function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgGithub = function SvgGithub(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.074 511.074",
    style: {
      enableBackground: "new 0 0 511.074 511.074"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M255.509,2.523C114.124,2.795-0.271,117.629,0,259.014c0.229,119.575,83.206,223.063,199.871,249.28 c5.752,1.272,11.446-2.359,12.719-8.111c0.167-0.755,0.252-1.526,0.252-2.3v-58.027c0-5.891-4.776-10.667-10.667-10.667h-21.333 c-26.624,0-44.8-25.237-60.736-47.509l-4.907-6.784c7.177,4.009,14.037,8.559,20.523,13.611 c12.002,11.177,27.445,17.947,43.797,19.2c16.081,2.238,30.931-8.983,33.169-25.064c0.313-2.249,0.364-4.526,0.153-6.787v-7.445 c0.001-4.766-3.16-8.955-7.744-10.261c-59.179-16.747-98.923-61.077-98.923-110.293c0.441-26.629,11.364-52.009,30.4-70.635 c3.073-3.167,3.878-7.899,2.027-11.904c-7.761-17.576-6.594-37.812,3.136-54.379c14.974,6.031,28.355,15.434,39.104,27.477 c2.893,3.433,7.627,4.687,11.84,3.136c40.626-14.648,85.092-14.648,125.717,0c4.195,1.521,8.893,0.269,11.776-3.136 c10.74-12.049,24.114-21.459,39.083-27.499c9.73,16.567,10.897,36.803,3.136,54.379c-1.852,4.005-1.046,8.737,2.027,11.904 c19.049,18.627,29.981,44.017,30.421,70.656c0,51.669-44.139,97.941-107.371,112.512c-5.741,1.32-9.326,7.044-8.006,12.785 c0.208,0.904,0.532,1.776,0.966,2.596c5.976,13.43,8.632,28.101,7.744,42.773v79.36c0,5.891,4.776,10.667,10.667,10.667 c0.775-0.003,1.547-0.089,2.304-0.256c137.945-30.999,224.642-167.955,193.643-305.899C478.572,85.729,375.084,2.753,255.509,2.523z "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGithub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/github.c517f7a2.svg";
export { ForwardRef as ReactComponent };